
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import SenkronAlanFrekansMatrisi from "@/components/eicrapro/senkron/SenkronAlanFrekansMatrisi.vue";
import SenkronDosyaSecDialog from "@/components/eicrapro/senkron/SenkronDosyaSecDialog.vue";
import Times from "@/components/inputs/Times.vue";
import {SenkronPlan, SenkronPlanDosya, SenkronPlanYazmaCevabi} from "@/services/senkronPlanService";
import {
  AZAMI_AD_UZUNLUGU,
  bosPlanFormu,
  formuGovdeyeCevir,
  planGecerliMi,
  planKaydetEylemi,
  plandanForm,
  saatGecerliMi,
  SenkronPlanFormu
} from "@/services/senkronPlanGovde";
import {seciliUcretliVarMi, alanSatirlariniKur} from "@/components/eicrapro/senkron/senkronAlanFrekans";
import {dosyaAnahtari, dosyaCikar} from "@/components/eicrapro/senkron/senkronDosyaSecimi";

/**
 * Plan oluştur/düzenle dialogu (Faz 3, DEV-2966).
 *
 * Kaydetme sonrası dialog KAPANIR; sunucunun `mesaj` alanı AYNEN, plan ekranının
 * üstündeki kalıcı şeritte gösterilir. Başta sunucunun mesajı okunsun diye dialog
 * açık bırakılmıştı ama manuel testte bu "kaydedilmedi mi?" izlenimi verdi.
 */
@Component({
  components: {SenkronAlanFrekansMatrisi, SenkronDosyaSecDialog, Times}
})
export default class SenkronPlanDialog extends Vue {
  @Prop({default: false}) value!: boolean;
  /** null ise yeni plan. */
  @Prop({default: null}) plan!: SenkronPlan | null;

  azamiAdUzunlugu = AZAMI_AD_UZUNLUGU;

  form: SenkronPlanFormu = bosPlanFormu();
  hatalar: Array<string> = [];
  kaydediliyor = false;
  dosyaDialogAcik = false;

  get acik(): boolean {
    return this.value;
  }

  set acik(deger: boolean) {
    this.$emit("input", deger);
  }

  get ucretliAlanSecili(): boolean {
    return seciliUcretliVarMi(alanSatirlariniKur(this.form.alanlar));
  }

  @Watch("value")
  onAcilis(acik: boolean) {
    if (!acik) return;
    this.form = this.plan ? plandanForm(this.plan) : bosPlanFormu();
    this.hatalar = [];
  }

  saatKurali(deger: string): boolean | string {
    return saatGecerliMi(deger) || "Koşum saati SS:DD biçiminde olmalıdır.";
  }

  /** Sihirbaz birleştirilmiş listeyi döndürür (ekleme yönü). */
  dosyalarSecildi(dosyalar: Array<SenkronPlanDosya>) {
    this.form.dosyalar = dosyalar;
  }

  /**
   * Dosya çıkarma BURADA yapılır: sihirbaz yalnız ekliyor. Aksi halde plandan
   * dosya düşürmek için sihirbazı açıp kapatmak gerekirdi.
   */
  dosyaSil(dosya: SenkronPlanDosya) {
    this.form.dosyalar = dosyaCikar(this.form.dosyalar, dosyaAnahtari(dosya));
  }

  /** `Times` @change ile emit ediyor; temizlenirse boş dizeye düşer. */
  kosumSaatiDegisti(deger: string | null) {
    this.form.kosumSaati = deger ?? "";
  }

  async kaydet() {
    this.hatalar = planGecerliMi(this.form);
    if (this.hatalar.length) return;

    this.kaydediliyor = true;

    try {
      const govde = formuGovdeyeCevir(this.form);
      // Hangi eylem çağrılacağı saf fonksiyondan gelir (birim testli): yanlış
      // seçim ya ikinci bir plan açar (çift sorgu / çift ücret) ya da 404 alır.
      const eylem = planKaydetEylemi(this.plan);
      const cevap: SenkronPlanYazmaCevabi = eylem === "senkronPlan/planGuncelle"
          ? await this.$store.dispatch(eylem, {id: this.plan!.id, govde})
          : await this.$store.dispatch(eylem, govde);

      // Sunucunun Türkçe `mesaj`ı ve (varsa) `hata`sı plan ekranına taşınıyor:
      // dialog kapandığı için burada gösterilseydi kullanıcı okuyamazdı.
      // "kaydettim, neden koşmadı" cevabı kaybolmamalı.
      this.$emit("kaydedildi", cevap);
      this.acik = false;
    } catch (e: any) {
      // 422 gövde doğrulaması global yanıt interceptor'ında gösteriliyor; burada
      // ikinci bir kutu kurmak aynı hatayı iki kez yazdırırdı. Dialog açık kalır.
      console.error("Senkron planı kaydedilemedi:", e);
    } finally {
      this.kaydediliyor = false;
    }
  }

  kapat() {
    this.acik = false;
  }
}
